module.exports = __webpack_public_path__ + "fonts/montserrat-bold.079ca05.ttf";